import type { LoadLevel } from '@core/line-probe';
import { BroadcastQuality } from '@core/types';
import { BROADCAST_QUALITY_PRESETS } from '../../../constants/broadcastQuality';

export type ActiveLoadLevel = Exclude<LoadLevel, 'off'>;

export const LOAD_LEVELS: LoadLevel[] = ['off', 'low', 'medium', 'high'];

const QUALITY: Record<ActiveLoadLevel, BroadcastQuality> = {
    low: BroadcastQuality.Low,
    medium: BroadcastQuality.Medium,
    high: BroadcastQuality.High
};

/** The load of a level: the video plus audio bitrate of the matching broadcast tier (spec 4.6), in kbit/s. */
export function loadKbps(level: ActiveLoadLevel): number {
    const preset = BROADCAST_QUALITY_PRESETS[QUALITY[level]];
    return (preset.videoBitrate + preset.audioBitrate) / 1000;
}

/** What five minutes at `kbps` cost in data, in whole megabytes: the test also runs on 4G hotspots. */
export function fiveMinuteMegabytes(kbps: number): number {
    return Math.round((kbps * 300) / 8 / 1000);
}
